module.exports = __webpack_public_path__ + "static/media/Kelloggs Blue Socks1st.1613fee2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Kelloggs Blue Socks1st.jpg
// module id = 179
// module chunks = 0